import { render, staticRenderFns } from "./BaseRadioGroup.vue?vue&type=template&id=dfd76574&scoped=true&"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=ts&"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd76574",
  null
  
)

export default component.exports